import {CLIENT_API_KEY} from '@constants/resources';
import {SECURITY_PRIVILEGES_UPDATE} from '@constants/variables';

export const authorizationObject = {
    [CLIENT_API_KEY]: SECURITY_PRIVILEGES_UPDATE,
};
